import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { Badge } from '@/components/ui/badge';
import { api } from '@/lib/api';
import { t } from '@/lib/i18n';

/** Which installation this is. Prod shows nothing; dev and local get a badge and a title prefix, so tabs are never mixed up. */
export function useEnvironment() {
  const health = useQuery({ queryKey: ['health'], queryFn: () => api.health(), staleTime: Infinity, retry: false });
  const environment = health.data?.environment;
  useEffect(() => {
    if (!environment || environment === 'prod') return;
    const prefix = `[${environment.toUpperCase()}] `;
    if (!document.title.startsWith(prefix)) document.title = prefix + document.title;
  }, [environment]);
  return { environment, version: health.data?.version };
}

export function EnvironmentBadge({ className }: { className?: string }) {
  const { environment, version } = useEnvironment();
  if (!environment || environment === 'prod') return null;
  return (
    <Badge tone="amber" className={className} title={t('Deskworks {environment} · version {version} — not the production installation', { environment, version: version ?? '?' })}>
      {environment.toUpperCase()}
    </Badge>
  );
}
